
/*!
* Copyright (c) Microsoft Corporation.
* All rights reserved. See LICENSE in the project root for license information.
* THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
* TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
*/
// tslint:disable
import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './DataServiceEntities.g';



// @ts-ignore
function kasHelpDeskControllerQuery(replicationCounterFromOrigin?: number): DataServiceQuery {
    const key = (replicationCounterFromOrigin) ? { ReplicationCounterFromOrigin: replicationCounterFromOrigin } :null;
    return new DataServiceQuery("KasHelpDeskController", "KasHelpDeskFormEntity", DataServiceEntities.KasHelpDeskFormEntityExtensionClass, key);
}


export function createCreateKasHelpDeskFormEntityInput(name: string, email: string, company: string, phone: string, city: string, state: string, country: string, business: string, body: string, site: string, requestType: string): IDataServiceRequest {
    const query = kasHelpDeskControllerQuery();
    return query.createDataServiceRequestForOperation('CreateKasHelpDeskFormEntity', true, '', 'false', {bypassCache: 'get', returnEntity: ''}, {name: name, email: email, company: company, phone: phone, city: city, state: state, country: country, business: business, body: body, site: site, requestType: requestType });
}


export function createKasHelpDeskFormEntityAsync(context: IContext, name: string, email: string, company: string, phone: string, city: string, state: string, country: string, business: string, body: string, site: string, requestType: string): AsyncResult<boolean> {
    const request = createCreateKasHelpDeskFormEntityInput(name, email, company, phone, city, state, country, business, body, site, requestType);
    return callActionOrExecute<boolean>(request, context.callerContext);
}
  